import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  RetirementPlanGridTableWrap
} from '../../components'
import Styles from './RetirementPlanListContainer.css'

@CSSModules(Styles)
export default class RetirementPlanListContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'Retirement plans',
      description: config.app.description,
      url: config.domain + config.routes.plans,
      viewAs: 0
    }
  }

  render() {
    return (
      <div styleName='page'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }

        <h1 styleName='rplc-tl'>
          401(k)s and similar retirement plans
        </h1>

        <p styleName='rplc-p'>
          We've rated 50+ employer-offered retirement plans for
          investments in fossil fuels, deforestation, weapons,
          private prisons, and more.
        </p>
        
        <RetirementPlanGridTableWrap />

        <ContainerDivs>
          <div styleName='content-wrap'>
            <h2>How are these companies chosen?</h2>
            <p>
              We think every retirement plan should be rated on sustainability.
              Our goal is to expand this database to cover the S&P 500.
              We've started with major companies
              that most people will recognize,
              covering hundreds of thousands of participants
              and billions in assets.
              But the sustainability issues with their retirement plans are
              not unique to these companies. Check back regularly to see
              if your employer has been added to our database.
            </p>
            <p>
              <b>Want us to rate the retirement plan of your
              employer? <Link
                to={config.links.contact}
                title='Contact us'
                xstrong
              >Get in touch with us<LinkIcon /></Link></b>
            </p>
          </div>
          <br/>
          <br/>
          <br/>
        </ContainerDivs>
      </div>
    )
  }
}